import { useEffect } from 'react';
import { Locale, setDefaultOptions } from 'date-fns';
import { nl, enUS, es } from 'date-fns/locale';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import i18n from '../../translations/i18n';

const fnsLocales: Record<string, Locale> = {
  nl,
  en: enUS,
  es,
};

export const useDateLocale = () => {
  useEffect(() => {
    const currentLocale = fnsLocales[i18n.language] || es;

    setDefaultOptions({ locale: currentLocale });
    dayjs.locale(i18n.language);
    dayjs.extend(customParseFormat);
  }, [i18n.language]);
};
